import React, { useState } from 'react';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import { LoginArea } from '@/components/auth/LoginArea';
import { X } from 'lucide-react';

export function SignedOutBanner() {
  const { user } = useCurrentUser();
  const [isDismissed, setIsDismissed] = useState(false);

  // Do not display if user logged in or explicitly dismissed banner
  if (user || isDismissed) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-sky-500 text-white z-40 py-3.5 px-4 backdrop-blur-md shadow-2xl flex items-center justify-center safe-bottom select-none">
      <div className="max-w-[1100px] w-full flex items-center justify-between gap-4">
        {/* Messages */}
        <div className="hidden sm:flex flex-col text-left leading-normal">
          <span className="font-extrabold text-lg">Don't miss what's happening</span>
          <span className="text-sm opacity-90">People on Twittstr are the first to know decentralized announcements.</span>
        </div>

        {/* Buttons / Actions CTAs */}
        <div className="flex items-center gap-3 w-full sm:w-auto">
          <LoginArea className="w-full sm:w-48 text-sky-500 font-bold" />
          
          <button 
            onClick={() => setIsDismissed(true)}
            className="p-2 hover:bg-white/10 rounded-full transition-colors cursor-pointer text-white"
            title="Dismiss banner"
          >
            <X className="size-5" />
          </button>
        </div>
      </div>
    </div>
  );
}
export default SignedOutBanner;
